import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import { Form, Input, Checkbox } from '../Form';
import Link from '../Link';
import { Brandmark } from '../Icons';
import Style from '../Style';
import { H3, L2, P1, P2 } from '../Typography';

class RegistrationForm extends React.PureComponent {
  static propTypes = {
    onRegister: PropTypes.func,
    onGoToLogin: PropTypes.func,
    error: PropTypes.string,
    message: PropTypes.string,
  };
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {
      fetching: false,
      formEnabled: true,

      email: '',
      password: '',
      agree: false,

      message: '',
      error: '',
    };
  }

  onSubmit = () => {
    if (!this.state.formEnabled) {
      return;
    }

    if (!this.state.agree) {
      this.setState({ error: 'You must agree to the terms and conditions' });
      return;
    }

    if (this.state.email.length < 5) {
      this.setState({ error: 'Please enter an email address.' });
      return;
    }

    if (this.state.password.length < 8) {
      this.setState({ error: 'Password must be at least 8 characters.' });
      return;
    }

    this.setState({ formEnabled: false, fetching: true, error: '' });
    this.props
      .onRegister(this.state.email, this.state.password)
      .then(() =>
        this.setState({
          fetching: false,
        }),
      )
      .catch(err =>
        this.setState({
          fetching: false,
          formEnabled: true,
          error: err.message,
        }),
      );
  };

  render() {
    const {
      onRegister,
      onGoToLogin,
      error,
      message,
      ...otherProps
    } = this.props;

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: '5rem 6rem 4rem',
        }}
      >
        <div>
          <Brandmark />
        </div>
        <H3 style={{ marginTop: '3rem' }}>Create Account</H3>
        <P1 style={{ color: Style.Colors.shadow3 }}>
          Upgrade, downgrade, or cancel anytime.
        </P1>
        <P1 style={{ color: Style.Colors.shadow3 }}>
          Already have an account?{' '}
          <Link underline={true} onClick={onGoToLogin}>
            Sign in.
          </Link>
        </P1>

        <Form onSubmit={this.onSubmit} enabled={this.state.formEnabled}>
          <Input
            name="email"
            type="email"
            value={this.state.email}
            onChange={value => this.setState({ email: value })}
          >
            YOUR EMAIL
          </Input>
          <Input
            name="password"
            type="password"
            value={this.state.password}
            onChange={value => this.setState({ password: value })}
          >
            CREATE A PASSWORD
          </Input>
        </Form>

        <div
          style={{
            width: '100%',
            textAlign: 'left',
            color: Style.Colors.error,
          }}
        >
          <P1>{this.state.error || error || message || <span>&nbsp;</span>}</P1>
        </div>

        <div
          style={{
            marginTop: '1.5rem',
          }}
        >
          <Checkbox
            checked={this.state.agree}
            onChange={value => this.setState({ agree: value })}
            labelStyle={{ color: Style.Colors.shadow3 }}
          >
            I agree to the{' '}
            <Link to="/legal" target="_blank" underline={true}>
              terms of use
            </Link>, and{' '}
            <Link to="/legal" target="_blank" underline={true}>
              privacy policy
            </Link>.
          </Checkbox>
        </div>

        <Button
          style={{ marginTop: '3rem' }}
          working={this.state.fetching}
          type="submit"
          onClick={this.onSubmit}
          arrow={true}
        >
          Continue
        </Button>
      </div>
    );
  }
}

export default RegistrationForm;



// WEBPACK FOOTER //
// ./src/components/RegistrationForm/RegistrationForm.js